import { render, staticRenderFns } from "./DangerZoneTimeSheet.vue?vue&type=template&id=dc480c36&scoped=true&"
import script from "./DangerZoneTimeSheet.vue?vue&type=script&lang=js&"
export * from "./DangerZoneTimeSheet.vue?vue&type=script&lang=js&"
import style0 from "./DangerZoneTimeSheet.vue?vue&type=style&index=0&id=dc480c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc480c36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
